// BSC Mainnet Contract Configuration
export const BSC_CHAIN_ID = 56;
export const BSC_RPC = 'https://bsc-dataseed1.binance.org/';

// USDT on BSC (BEP-20)
export const USDT_ADDRESS = '0x55d398326f99059fF775485246999027B3197955';

// DUSD Token (上币费支付代币)
export const DUSD_ADDRESS = '0x0d60C20FbE8e68A7ecB5d8E7eEC6792eaF96A368';

// 添加代币上币费：10000 DUSD
export const ADD_TOKEN_FEE = '10000';

// 上币费收款地址
export const ADD_TOKEN_FEE_RECEIVER = '0xFF0a8254aEC42925B5ac93E516930C03a324c611';

// PancakeSwap V2 Router on BSC
export const PANCAKE_ROUTER_ADDRESS = '0x10ED43C718714eb63d5aA57B78B54704E256024E';
// PancakeSwap V2 Factory
export const PANCAKE_FACTORY_ADDRESS = '0xcA143Ce32Fe78f1f7019d7d551a6402fC5350c73';
// PancakeSwap WBNB
export const WBNB_ADDRESS = '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c';

// Migration threshold: 2026 USDT（与合约 migrationThreshold = 2026 * 1e18 一致）
export const MIGRATION_THRESHOLD = '2026';

// Bonding Curve Contract (部署后填入)
export const BONDING_CURVE_ADDRESS = '0x2dc251dff3b01b01c8b794b11908d189dad4ed56';

// ERC20 ABI (minimal)
export const ERC20_ABI = [
  'function name() view returns (string)',
  'function symbol() view returns (string)',
  'function decimals() view returns (uint8)',
  'function totalSupply() view returns (uint256)',
  'function balanceOf(address) view returns (uint256)',
  'function allowance(address owner, address spender) view returns (uint256)',
  'function approve(address spender, uint256 amount) returns (bool)',
  'function transfer(address to, uint256 amount) returns (bool)',
  'function transferFrom(address from, address to, uint256 amount) returns (bool)',
  'event Transfer(address indexed from, address indexed to, uint256 value)',
  'event Approval(address indexed owner, address indexed spender, uint256 value)',
];

// BondingCurve ABI
export const BONDING_CURVE_ABI = [
  // View functions
  'function getTokenInfo(address token) view returns (tuple(address tokenAddress, string name, string symbol, uint8 decimals, uint256 totalSupply, uint256 reserveUSDT, uint256 tokenBalance, uint256 initialTokenAmount, uint256 currentPrice, bool migrated, bool active, address creator, uint256 createdAt, string description, string website))',
  'function getPrice(address token) view returns (uint256)',
  'function getBuyPrice(address token, uint256 usdtAmount) view returns (uint256)',
  'function getSellPrice(address token, uint256 tokenAmount) view returns (uint256)',
  'function getAllTokens() view returns (address[])',
  'function isTokenListed(address token) view returns (bool)',
  'function migrationThreshold() view returns (uint256)',
  'function platformFeeRate() view returns (uint256)',
  'function feeCollector() view returns (address)',
  'function listingFee() view returns (uint256)',
  'function listingFeeReceiver() view returns (address)',

  // State-changing functions
  'function addToken(address token, uint256 initialTokenAmount, string description, string website) returns (bool)',
  'function buyTokens(address token, uint256 usdtAmount, uint256 minTokenOut) returns (uint256)',
  'function sellTokens(address token, uint256 tokenAmount, uint256 minUsdtOut) returns (uint256)',
  'function migrateToPancakeSwap(address token) returns (bool)',

  // Admin functions
  'function setMigrationThreshold(uint256 newThreshold)',
  'function setPlatformFeeRate(uint256 newRate)',
  'function setFeeCollector(address newCollector)',
  'function setListingFee(uint256 newFee)',
  'function setListingFeeReceiver(address newReceiver)',
  'function transferOwnership(address newOwner)',
  'function deactivateToken(address token)',
  'function reactivateToken(address token)',
  'function emergencyWithdraw(address tokenAddr, uint256 amount)',

  // Events
  'event TokenAdded(address indexed token, address indexed creator, uint256 timestamp)',
  'event TokensBought(address indexed buyer, address indexed token, uint256 usdtIn, uint256 tokensOut, uint256 newPrice, uint256 fee)',
  'event TokensSold(address indexed seller, address indexed token, uint256 tokensIn, uint256 usdtOut, uint256 newPrice, uint256 fee)',
  'event LiquidityMigrated(address indexed token, uint256 usdtAmount, uint256 tokenAmount, address pancakePair)',
];

// PancakeSwap Router ABI (minimal)
export const PANCAKE_ROUTER_ABI = [
  'function addLiquidity(address tokenA, address tokenB, uint amountADesired, uint amountBDesired, uint amountAMin, uint amountBMin, address to, uint deadline) returns (uint amountA, uint amountB, uint liquidity)',
  'function swapExactTokensForTokens(uint amountIn, uint amountOutMin, address[] calldata path, address to, uint deadline) returns (uint[] memory amounts)',
  'function getAmountsOut(uint amountIn, address[] calldata path) view returns (uint[] memory amounts)',
];
